export default 'Select Hue';